import { render, staticRenderFns } from "./_TopLevelMenuItem.vue?vue&type=template&id=3dddd6b7&"
import script from "./_TopLevelMenuItem.vue?vue&type=script&lang=ts&"
export * from "./_TopLevelMenuItem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dddd6b7')) {
      api.createRecord('3dddd6b7', component.options)
    } else {
      api.reload('3dddd6b7', component.options)
    }
    module.hot.accept("./_TopLevelMenuItem.vue?vue&type=template&id=3dddd6b7&", function () {
      api.rerender('3dddd6b7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/powerbar/components/PowerbarNav/_TopLevelMenuItem.vue"
export default component.exports